var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"chat-card"},[_c('b-row',{staticClass:"ml-0"},[_c('h4',{staticClass:"font-weight-bold card-title"},[_vm._v(" Chat ")])]),_c('ChatArea2')],1)}
var staticRenderFns = []

export { render, staticRenderFns }